import { FetchHttpClient } from "src/app/infrastructure/FetchHttpClient";

const httpClient = new FetchHttpClient();

export default httpClient;


// WEBPACK FOOTER //
// ./src/app/modules/core/infrastructure/httpClient.ts